/** Shared toolbar / row action glyphs (Heroicons outline, viewBox 0 0 24 24). */

export const ACTION_ICON_STROKE = 2;

/** Toolbar and page-header icon buttons. */
export const ACTION_ICON_TOOLBAR_PX = 20;
export const ACTION_ICON_TOOLBAR_HIT_PX = 40;

/** In-table and compact icon buttons — existing `w-4` in `.btn-icon.btn-sm` (2rem). */
export const ACTION_ICON_ROW_PX = 16;
export const ACTION_ICON_ROW_HIT_PX = 32;

export type ActionIconName =
  | 'edit'
  | 'delete'
  | 'add'
  | 'search'
  | 'close'
  | 'export'
  | 'download'
  | 'confirm'
  | 'cenik'
  | 'transfer'
  | 'compass';

export type IconButtonDensity = '' | 'toolbar' | 'row';

export const ACTION_ICON_PATHS: Record<ActionIconName, string> = {
  edit:
    'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
  delete:
    'M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16',
  add: 'M12 4v16m8-8H4',
  search: 'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z',
  close: 'M6 18L18 6M6 6l12 12',
  export:
    'M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  download: 'M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4',
  confirm: 'M5 13l4 4L19 7',
  /** Currency circle — same metaphor as HR → Ceník nav. */
  cenik:
    'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  /** Swap arrows — skladový / zařízení převod (Odkud → Kam). */
  transfer: 'M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4',
  /** Circle with a north needle — průvodce v horní liště. */
  compass: 'M12 20.5a8.5 8.5 0 100-17 8.5 8.5 0 000 17M12 16.25V8.25M9.7 10.7L12 8.25l2.3 2.45',
};

const ACTION_ICON_LABELS: Record<ActionIconName, string> = {
  edit: 'Upravit',
  delete: 'Odstranit',
  add: 'Přidat',
  search: 'Hledat',
  close: 'Zavřít',
  export: 'Exportovat',
  download: 'Stáhnout',
  confirm: 'Schválit',
  cenik: 'Ceník',
  transfer: 'Převod',
  compass: 'Průvodce',
};

export function defaultActionIconLabel(name: ActionIconName): string {
  return ACTION_ICON_LABELS[name];
}
